import { platform } from './transportWrapper';
import { ICoa, ICoaMask } from './types';

export const getEntityCoAs = async (entityId: string | number, clientOptions?: RequestInit) =>
  platform
    .options(clientOptions, true)
    .url(`/api/v3/chart_of_accounts/?entity_id=${entityId}`)
    .get()
    .json()
    .then((coas: ICoa[]): ICoa[] => {
      return coas;
    })
    .catch(async (e) => {
      e.message = `getEntityCoAs: ${e.message}, entityId: ${entityId}`;
      return Promise.reject(e);
    });

export const deleteCoaById = async (coaId: string | number, clientOptions?: RequestInit) =>
  platform.options(clientOptions, true).url(`/api/v3/chart_of_accounts/${coaId}`).delete();

export const getCoaMasks = async (coaId: string | number, clientOptions?: RequestInit) =>
  platform
    .options(clientOptions, true)
    .url(`/api/v1/coa_masks/?coa=${coaId}`)
    .get()
    .json()
    .then((data: { coa_masks: ICoaMask[] }) => data.coa_masks)
    .catch(async (e) => {
      e.message = `getCoaMasks: ${e.message}, coaId: ${coaId}`;
      return Promise.reject(e);
    });

export const deleteCoaMask = async (maskId: string | number, clientOptions?: RequestInit) =>
  platform.options(clientOptions, true).url(`/api/v1/coa_masks/${maskId}`).delete();
